export const getImagesNextPage = (state) => {
	return state.google.imagesNextPage;
};

export const getImages = (state) => {
	return state.google.images;
};
